import { AsyncThunkAction } from '@reduxjs/toolkit';
import {
	Filters,
	PaginationFilterContext,
	usePagination,
} from 'shared/lib/pagination';
import { FC, ReactNode } from 'react';

interface PaginationProviderProps {
	fetchData: (filters: Filters) => AsyncThunkAction<any, any, any>;
	children: ReactNode;
}

export const PaginationFilterProvider: FC<PaginationProviderProps> = ({
	fetchData,
	children,
}) => {
	const props = usePagination(fetchData);
	return (
		<PaginationFilterContext.Provider value={{ ...props }}>
			{children}
		</PaginationFilterContext.Provider>
	);
};
